import React from 'react';
import { TELEGRAM_LINK } from '../config';

const Contact = () => {

  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="contact-title">지금 바로 시작하세요</h2>
            <p className="contact-description">
              텔레그램으로 문의하시면 빠르게 답변드립니다.<br />
              맞춤형 솔루션을 제안해드립니다.
            </p>
            <a href={TELEGRAM_LINK} target="_blank" rel="noopener noreferrer" className="btn-telegram-large">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.559z" />
              </svg>
              텔레그램으로 문의하기
            </a>
          </div>
          <div className="contact-visual">
            <div className="contact-card">
              <div className="contact-card-header">
                <div className="contact-card-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="contact-card-content">
                <div className="telegram-icon-large">✈️</div>
                <h3>텔레그램 문의</h3>
                <p>실시간으로 빠른 답변을 받으세요</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
